import { Enrollment } from './../../core/models/enrollment';
import { EnrollmentService } from './../../core/services/enrollment.service';
import { TeacherService } from 'src/app/core/services/teacher.service';
import { CourseService } from 'src/app/core/services/course.service';
import { takeUntil } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BaseComponent } from 'src/app/components/base/base.component';
import { AlertService } from 'src/app/core/services/alert.service';
import { BaseService } from 'src/app/core/services/base.service';
import { Course } from '../../core/models/course';
import { Category } from '../../core/models/category';
import { Teacher } from 'src/app/core/models/teacher';


@Component({
  selector: 'app-teacher-cources',
  templateUrl: './teacher-cources.component.html',
  styleUrls: ['./teacher-cources.component.scss']
})
export class TeacherCourcesComponent extends BaseComponent implements OnInit {

  userFullName: string;
  teacherId: number;

  tokenValid: boolean;

  courses: Course[];
  isTeacher: string;
  categories: Category[];

  noCoursesForThisTeacherSection: boolean = false;

  p: number = 1;
  teacher = {} as Teacher;

  userName: string;
  academyToken: string;

  userId: number;
  enrollments: Enrollment[];
  noEnrollYet: boolean = false;

  constructor(
    public baseService:BaseService,
    private alertService: AlertService,
    private route :ActivatedRoute,
    private router: Router,
    private translate: TranslateService,
    private courseService: CourseService,
    private teacherService: TeacherService,
    private enrollmentService: EnrollmentService
  ) { super() }

  ngOnInit(): void {
    this.userFullName = localStorage.getItem('userFullName');

    var teachId = localStorage.getItem('teacherId');
    this.teacherId = Number(teachId);

    var useID = localStorage.getItem('userId');
    this.userId = Number(useID);

    this.userName = localStorage.getItem('userName');
    this.academyToken = localStorage.getItem('academyToken'); 

    const token = localStorage.getItem('token');
    const isTeacher = localStorage.getItem('isTeacher');
    this.isTeacher = isTeacher
    if (token && isTeacher) { this.tokenValid = true; }
    else { this.tokenValid = false; }

    this.courseService.getCourseByTeacherId(this.teacherId).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      (data: any) => {
        this.courses = data.result.returnData;
        // console.log(this.courses)
      }
    )

    this.teacherService.get(this.teacherId).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      (data: any) => {
        this.teacher = data.result.returnData;
        // console.log(this.teacher)
      }
    )

    this.loadData();
  }

  loadData(){
    this.route.data.pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      data=>{
        this.categories = data.categories.result.returnData;
        // console.log(this.courses)
      });
  }

  viewProfile(id) {
    this.router.navigate(['/teacher-profile/edit', this.teacherId]);
  }

  viewCourses(id) {
    this.router.navigate(['/teacher-courses/edit', this.teacherId]);
  }

  viewSettings(id) {
    debugger
    this.router.navigate(['/teacher-settings/edit', this.teacherId]);
  }

  ViewPayments(id) {
    this.router.navigate(['/teacher-payments/edit', this.teacherId]);
  }

  editCourse(id) {
    this.router.navigate(['/create-course/edit', id]);
  }
  viewCourseDetails(id) {
    this.router.navigate(['/course-details/edit', id]);
  }

  logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('academyToken');
    localStorage.removeItem('studentId');
    localStorage.removeItem('profileImg');
    localStorage.removeItem('userId');
    localStorage.removeItem('isTeacher');
    localStorage.removeItem('teacherId');
    localStorage.removeItem('userFullName');
    localStorage.removeItem('token');

    this.router.navigate(['/home']);

    setTimeout(() => {
      this.router.navigate(['/home']);
    }, 200);
    if (!localStorage.getItem('up')) {
      localStorage.setItem('up', 'no reload');
      location.reload();
    } else {
      localStorage.removeItem('up');
    }
  }

  getCategoryId(e) {
    this.baseService.blockStart();
    if(e.selectedItem === null) {
      this.courseService.getCourseByTeacherId(this.teacherId).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
        (data: any) => {
          this.baseService.blockStop();
          this.courses = data.result.returnData;
          // console.log(this.courses);
        }
      )
    }
    else if (e.selectedItem !== null) {
      this.courseService.getCoursesByTeacherAndCategoryId(e.selectedItem.id, this.teacherId).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
        (data: any) => {
          if (data.result.returnData.length === 0) {
            this.baseService.blockStop();
            this.noCoursesForThisTeacherSection = true;
          }
          else if (data.result.returnData.length !== 0) {
            this.baseService.blockStop();
            this.noCoursesForThisTeacherSection = false;
            this.courses = data.result.returnData;
          }
        }
      )
    }
  }

  searchByName(e) {
    debugger
    // console.log(e.target.value);
    this.courseService.searchCoursesByTeacherId(e.target.value, this.teacherId).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      (data: any) => {
        // console.log(data)
      }
    )
  }


  goToLMS(id) {
    window.open('https://academy-lms.learnyhome.com/index.php?r=adm/homepage/login&plugin=FormaAuth&from_academy=1&login_userid='+ this.userName +'&token='+ this.academyToken + '&course_external_id=' + id, "_blank");
  }

  deleteCourse(id) {
    debugger
    this.courseService.delete(id, this.userId, this.academyToken).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      (data: any) => {
        if (data.result.message.type === 'Success') {
          this.courseService.getCourseByTeacherId(this.teacherId).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
            (data: any) => {
              this.courses = data.result.returnData;
              this.alertService.success(this.translate.instant('courseDeleted'));
            }
          )
        }
        else if (data.result.message.type === 'Error') {
          if (data.result.message.content === 'Could not Remove Course') {
            this.alertService.error(this.translate.instant('CouldnotRemove'));
          }
        }
        // console.log(data)
      }
    )
  }

  showEnrolledStudents(id) {
    debugger
    this.enrollmentService.getByCourseId(id).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      (data: any) => {
        this.enrollments = data.result.returnData;
        if (this.enrollments.length === 0) {
          this.noEnrollYet = true;
        }
        else if (this.enrollments.length !== 0) {
          this.noEnrollYet = false;
        }
      }
    )
  }

  clearEnrollments() {
    this.enrollments = [];
    this.noEnrollYet = true;
  }

}
